/* eslint-disable react-hooks/exhaustive-deps */
import VisibilityIcon from '@mui/icons-material/Visibility';
import React, { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import { GET } from '../../../services/rest.service';

import $ from 'jquery';
import { useParams } from 'react-router';
import { formatPhoneNumber } from '../../../helpers/helper';

const ApplicationDetails = () => {
  const [records, setRecords] = useState({ applications: [] });
  const { id } = useParams();

  const getJob = async () => {
    try {
      const { data } = await GET(`/admin/job-posting/getById/${id}`);
      setRecords({ applications: data.applications });
    } catch (err) {
      toast.error(err.message);
    }
  };

  useEffect(() => {
    $(function () {
      $('.scroll-main').on('scroll', function () {
        $('.scroll-child').scrollLeft($('.scroll-main').scrollLeft());
      });
      $('.scroll-child').on('scroll', function () {
        $('.scroll-main').scrollLeft($('.scroll-child').scrollLeft());
      });
    });

    getJob();
  }, []);

  return (
    <div className="container-fluid px-xl-5">
      <section className="py-5">
        <div className="row">
          <div className="col-12">
            <div className="card">
              <div className="card-header d-flex justify-content-between align-items-center">
                <h6 className="text-uppercase mb-0">Applicants List</h6>
              </div>
              <div className="card-body">
                <div className={'table-responsive'}>
                  <table className="table card-text">
                    <thead>
                      <tr>
                        <th>Name</th>
                        <th>Email</th>
                        <th>Phone No.</th>
                        <th>Cover Letter</th>
                        <th>Resume</th>
                        <th>&nbsp;</th>
                      </tr>
                    </thead>
                    <tbody>
                      {records.applications.map((record) => (
                        <tr>
                          <td>{record.name}</td>
                          <td>{record.email}</td>
                          <td>{formatPhoneNumber(record.phone)}</td>
                          <td>
                            <a className="py-2" target="_blank" href={record.coverLetter?.url} rel="noreferrer">
                              <VisibilityIcon /> {'View'}
                            </a>
                          </td>
                          <td>
                            <a className="py-2" target="_blank" href={record.resume.url} rel="noreferrer">
                              <VisibilityIcon /> {'View'}
                            </a>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default ApplicationDetails;
